module.exports = __webpack_public_path__ + "img/mind_template_item_1_3.b43cbe07.png";